<template>
    <div class="c-form-wrap-submit" v-bind:class="ComputedClass">
        <label class="c-form-wrap-submit__field-name">{{label}}</label>

        <div class="c-form-wrap-submit__field-wrap">
            <div class="c-form-wrap-submit__input-wrap c-form-wrap-submit__input-wrap--button">
                <input class="c-form-wrap-submit__input "
                       v-model="localValue"
                       @focus="focus"
                       @focusout="focusOut"
                       v-validate="validation"
                       :name="fieldName"
                       :type="type"
                       ref="input"
                       :disabled="isApprove"
                       :data-vv-name="fieldName"
                       :readonly="isLoad"
                       v-on:keypress.enter="submit"
                       v-mask="mask"
                       v-if="mask"
                >
                <input class="c-form-wrap-submit__input"
                       v-model="localValue"
                       @focus="focus"
                       @focusout="focusOut"
                       v-validate="validation"
                       :name="fieldName"
                       :type="type"
                       ref="input"
                       :readonly="isLoad"
                       :disabled="isApprove"
                       :data-vv-name="fieldName"
                       v-on:keypress.enter="submit"
                       v-else>
                <span v-if="showPlaceholder" class="c-form-wrap-submit__input-placeholder">{{placehoderMask}}</span>
            </div>
            <svg class='c-form-wrap-submit__button' ref="button" v-on:click="submit" xmlns="http://www.w3.org/2000/svg"
                 width="56" height="56"
                 :disabled="isLoad || isLoadEnd"
                 viewBox="0 0 45 45">
                <circle class="c-form-wrap-submit__button-circle" cx="22.5" cy="22.5" r="22.5"/>
                <g class="c-form-wrap-submit__button-icon">
                    <circle class="c-form-wrap-submit__button-line-clr" cx="22.5" cy="22.5" r="13"/>
                    <path transform="translate(-1.5,-1.5)"
                          class="c-form-wrap-submit__button-line c-form-wrap-submit__button-line-clr"
                          d="M21,14,31,24,21,34s-4.292,2.479-8-3a12.413,12.413,0,0,1-2-7,13.029,13.029,0,0,1,24-7L21,31l-7-7"/>
                </g>
            </svg>
        </div>

        <span class="c-form-wrap-submit__tooltip" ref="tooltip">
            <span class="c-form-wrap-submit__hidden">
                <template v-if="isError && !focusField">
                    <template v-if="externalError.haveError">
                        {{externalError.errorText}}
                    </template>
                    <template v-else>
                        {{ errors.first(fieldName)}}
                    </template>
                </template>
                <template v-else>

                    <slot name="hint"></slot>
                </template>
            </span>
            <slot name="tooltip"></slot>
        </span>
    </div>
</template>

<script>
    import {STATUSES} from "../statuses";
    import cInput from "./input";

    export default {
        name: "cInputSubmit",
        extends: cInput,
        props: {
            sendFunction: {
                type: Function,
                required: true
            }
        },
        data() {
            return {};
        },
        watch: {},
        methods: {
            submit(event) {
                let _this = this;
                this.$validator.validate().then(result => {
                    _this.$refs.tooltip.focus();
                    _this.focusField = false;
                    if (!result) {
                        //error
                    } else {
                        this.sendFunction();
                    }
                });
            }
        },
        computed: {
            isLoad: function () {
                return this.externalStatus === STATUSES.LOAD;
            },
            isLoadEnd: function () {
                return this.externalStatus === STATUSES.LOAD_END;
            },
            ComputedClass: function () {
                return {
                    "c-form-wrap-submit--empty": this.isEmpty,
                    "c-form-wrap-submit--focus": this.isFocus,
                    "c-form-wrap-submit--filled": this.isFilled,
                    "c-form-wrap-submit--show-button": this.isFullFilled && !this.isEmpty,

                    "c-form-wrap-submit--load": this.isLoad,
                    "c-form-wrap-submit--load-end": this.isLoadEnd,
                    "c-form-wrap-submit--error": this.isError && !this.focusField,

                    "c-form-wrap-submit--complete": this.isComplete,
                    "c-form-wrap-submit--approve": this.isApprove
                };
            }
        },
        asyncComputed: {
            isFullFilled: {
                // TODO:  Дописать проверку с длинной маски.
                get() {
                    return this.$validator.validate(this.fieldName, this.value);
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    .c-form-wrap-submit {
        box-sizing: border-box;
        margin: 0 10px 10px;
        text-align: left;
        font-family: $RobotoRegular;
        position: relative;
        &__field-name {
            padding-left: 10px;
            display: block;
            position: absolute;
            font-size: 14px;
            transform: translateY(-50%);
            transition: all ease 0.1s;
            top: 28px;
            line-height: 1.2;
            color: #4a4a4a;
        }
        &__input-wrap {
            position: relative;
            vertical-align: top;
            &::before {
                left: 0;
                content: "";
                height: 1px;
                position: absolute;
                bottom: 0;
                width: 100%;
                z-index: 20;
                background: #979797;
            }
            &::after {
                left: 0;
                content: "";
                height: 2px;
                position: absolute;
                bottom: 0;
                width: 0;
                transition: all ease 0.3s;
                z-index: 21;
                background: $violet;
            }
        }
        &__input {
            background-color: rgba(255, 183, 0, 0.04);
            border: none;
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            font-family: $RobotoRegular;
            font-size: 14px;
            padding: 25px 10px 10px 10px;
        }
        &__input-placeholder {
            position: absolute;
            font-size: 14px;
            font-family: $RobotoRegular;
            top: 25px;
            left: 10px;
        }
        &__tooltip {
            font-size: 12px;
            color: #9b9b9b;
            padding: 0 10px;
            margin-top: 10px;
            line-height: 1.5;
            display: block;
            max-width: 100%;
            width: 100%;
            .text--blue {
                font-size: 12px;
                color: #3083e2;
            }
        }
        &__hidden {
            font-size: inherit;
            color: inherit;
        }
        &__button {
            -webkit-transition: all 0.1s ease;
            -moz-transition: all 0.1s ease;
            -o-transition: all 0.1s ease;
            transition: all 0.1s ease;
            transform-origin: 22.5px 22.5px;
            display: none;
            &:hover {
                cursor: pointer;
            }
        }
        &__button-circle {
            fill: #d7afd6;
            -webkit-transition: all 0.1s ease;
            -moz-transition: all 0.1s ease;
            -o-transition: all 0.1s ease;
            transition: all 0.1s ease;
            transform-origin: 22.5px 22.5px;
            &:active {
                fill: #f8cff7;
            }
        }
        &__button-line {
            stroke: #93278f;
            stroke-miterlimit: 10;
            stroke-width: 2px;
            stroke-dasharray: 28 81;
            stroke-dashoffset: 0;
        }
        &__button-line-clr {
            fill: none;
        }
    }

    .c-form-wrap-submit {
        $blockname: &;
        &.c-form-wrap-submit--empty {
            #{$blockname}__button {
                display: none;
            }
            #{$blockname}__button {
                display: none;
            }
        }
        &.c-form-wrap-submit--focus {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }
        &.c-form-wrap-submit--filled {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
        }
        &.c-form-wrap-submit--show-button {
            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: calc(100% - 65px);
                width: 100%;
                margin-right: 5px;
            }
            #{$blockname}__button {
                display: inline-block;
            }
        }
        &.c-form-wrap-submit--error {
            #{$blockname}__field-name {
                color: $error;
            }
            #{$blockname}__input-wrap {
                &::after {
                    width: 100%;
                    background: $error;
                }
            }
            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: 100%;
                width: 100%;
                margin-right: 0;
            }
            #{$blockname}__input {
                background-color: rgba(255, 78, 0, 0.12);
            }
            #{$blockname}__tooltip {
                color: $error;
            }
            #{$blockname}__button {
                display: none;
            }
        }
        &.c-form-wrap-submit--load {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: #d4b7d7;
                z-index: 21;
            }
            #{$blockname}__input-wrap {
                position: relative;
                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: #d1bdcf;
                }
            }
            #{$blockname}__input {
                background-color: #fffefb;
                color: #b8b8b7;
            }
            #{$blockname}__input-placeholder {
                display: none;
            }
            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: calc(100% - 65px);
                width: 100%;
                margin-right: 5px;
            }
            #{$blockname}__button {
                display: inline-block;
            }
            #{$blockname}__button-line {
                stroke: #93278f;
                stroke-miterlimit: 10;
                stroke-width: 2px;
                stroke-dasharray: 29 80;
                stroke-dashoffset: 0;
                animation: set_wait 0.5s linear 1 both;
            }
            #{$blockname}__button-icon {
                animation: waiting 0.5s linear 0.5s infinite;
                transform-origin: 22.5px 22.5px;
            }
        }
        &.c-form-wrap-submit--load-end {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 15px;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: $violet;
            }
            #{$blockname}__input-wrap {
                position: relative;

                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
            #{$blockname}__input {
                background-color: rgba(255, 183, 0, 0.12);
            }

            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: calc(100% - 65px);
                width: 100%;
                transition: 0.3s ease width;
                margin-right: 5px;
            }
            #{$blockname}__input-placeholder {
                display: none;
            }
            #{$blockname}__button {
                display: inline-block;
            }

            #{$blockname}__button-line {
                stroke: #93278f;
                stroke-miterlimit: 10;
                stroke-width: 2px;
                stroke-dasharray: 29 80;
                stroke-dashoffset: 0;
                animation: set_ok 0.3s linear 0s both;
            }
            #{$blockname}__button-icon {
                animation: waiting 0.5s linear 0s 1;
                transform-origin: 22.5px 22.5px;
            }
        }
        &.c-form-wrap-submit--complete {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 16px;
                z-index: 21;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: #9b9b9b;
            }
            #{$blockname}__input-wrap {
                position: relative;

                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    left: 0;
                    content: "";
                    height: 2px;
                    position: absolute;
                    bottom: 0;
                    width: 0;
                    transition: all ease 0.3s;
                    z-index: 21;
                    background: $violet;
                }
            }
            #{$blockname}__input {
                background-color: #ffffff;
                color: $yellow-1;
                font-size: 14px;
                transition: all ease 0.3s;
                text-decoration: underline;
                text-align: right;
                padding: 5px 10px;
            }
            #{$blockname}__input-placeholder {
                display: none;
            }
            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: 100%;
                width: 100%;
                transition: 0.3s ease width;
            }
            #{$blockname}__button {
                display: none;
            }
            #{$blockname}__hidden {
                display: none;
            }
        }
        &.c-form-wrap-submit--approve {
            #{$blockname}__field-name {
                padding-left: 10px;
                display: block;
                position: absolute;
                font-size: 14px;
                transform: translateY(-50%);
                top: 16px;
                z-index: 21;
                transition: all ease 0.08s;
                line-height: 1.2;
                color: #9b9b9b;
            }
            #{$blockname}__input-wrap {
                position: relative;

                &::before {
                    left: 0;
                    content: "";
                    height: 1px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    z-index: 20;
                    background: #979797;
                }
                &::after {
                    width: 0;
                }
            }
            #{$blockname}__input {
                background-color: #ffffff;
                color: #9b9b9b;
                font-size: 14px;
                transition: all ease 0.3s;
                text-decoration: none;
                text-align: right;
                padding: 5px 10px;
            }
            #{$blockname}__input-placeholder {
                display: none;
            }
            #{$blockname}__input-wrap--button {
                display: inline-block;
                max-width: 100%;
                width: 100%;
            }
            #{$blockname}__button {
                display: none;
            }
            #{$blockname}__hidden {
                display: none;
            }
        }
    }

    @keyframes set_next {
        0% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: -49;
        }
        100% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: 0;
        }
    }

    @keyframes set_wait {
        0% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: 0;
        }
        100% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: -49;
        }
    }

    @keyframes waiting {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes set_ok {
        0% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: -49;
        }
        100% {
            stroke-dasharray: 29 80;
            stroke-dashoffset: -80;
        }
    }

    @media screen and (max-width: 1024px) {
    }
</style>
